<script>
    export let name;
    export let choice = "1-1";
    export let curnickname = "";

    import { onMount } from "svelte";

    let cnusername = ""
    let permits = []

    function setChoice(targetval) {
        choice = targetval;
    }

    // 加载事件函数
    onMount(() => {
        let sUrl = "/dbapi/userdetail?nickname=" + curnickname;
        jQuery.ajax({
            type: "get",
            url: sUrl,
            success: function (response) {
                if (response.code == 200) {
                    let ud = response.result;
                    cnusername = ud.cnname;
                    permits = ud.permitcodes;
                } else {
                    console.log("sidebar:get user permits error.");
                }
            },
            error: function (err) {
                console.log("sidebar:get user permits exception.");
            },
        });
    });

</script>

<aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <a href={"javascript:;"} class="brand-link">
        <img
            src="./img/logo.png"
            alt="Logo"
            class="brand-image img-circle elevation-3"
            style="opacity: .8"
        />
        <span class="brand-text font-weight-light">&nbsp;{name}</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">
        <!-- Sidebar user -->
        <div class="user-panel mt-3 pb-3 mb-3 d-flex">
            <div class="image">
                <img
                    src="./img/user.jpg"
                    class="img-circle elevation-2"
                    alt="照片"
                />
            </div>
            <div class="info">
                <a href={"javascript:;"} class="d-block">&nbsp;{cnusername}</a>
            </div>
        </div>
        <!-- SidebarSearch Form -->
        <div class="form-inline">
            <div class="input-group" data-widget="sidebar-search">
                <input
                    class="form-control form-control-sidebar"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                />
                <div class="input-group-append">
                    <button class="btn btn-sidebar">
                        <i class="bi bi-search" />
                    </button>
                </div>
            </div>
        </div>
        <!-- Sidebar Menu -->
        <nav class="mt-2">
            <ul
                class="nav nav-pills nav-sidebar flex-column"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
            >
                <li class="nav-item">
                    <a
                        href={"javascript:;"}
                        class="nav-link"
                        class:active={choice.startsWith("1-")}
                    >
                        <i class="nav-icon bi bi-app-indicator" />
                        <p>
                            工作台
                            <i class="right bi bi-chevron-left" />
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "1-1"}
                                on:click={() => setChoice("1-1")}
                            >
                                <i class="bi bi-circle" />
                                <p>数据看板</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "1-2"}
                                on:click={() => setChoice("1-2")}
                            >
                                <i class="bi bi-circle" />
                                <p>个人设置</p>
                            </a>
                        </li>
                    </ul>
                </li>
                {#if permits.includes("P002")}
                <li class="nav-item">
                    <a
                        href={"javascript:;"}
                        class="nav-link"
                        class:active={choice.startsWith("2-")}
                    >
                        <i class="nav-icon bi bi-map" />
                        <p>
                            综合监控
                            <i class="right bi bi-chevron-left" />
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "2-1"}
                                on:click={() => setChoice("2-1")}
                            >
                                <i class="bi bi-circle" />
                                <p>状态查看</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "2-2"}
                                on:click={() => setChoice("2-2")}
                            >
                                <i class="bi bi-circle" />
                                <p>历史数据</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "2-3"}
                                on:click={() => setChoice("2-3")}
                            >
                                <i class="bi bi-circle" />
                                <p>异常发现</p>
                            </a>
                        </li>
                    </ul>
                </li>
                {/if}
                {#if permits.includes("P001")}
                <li class="nav-item">
                    <a
                        href={"javascript:;"}
                        class="nav-link"
                        class:active={choice.startsWith("3-")}
                    >
                        <i class="nav-icon bi bi-map" />
                        <p>
                            设备管理
                            <i class="right bi bi-chevron-left" />
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "3-1"}
                                on:click={() => setChoice("3-1")}
                            >
                                <i class="bi bi-circle" />
                                <p>版本查询</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "3-2"}
                                on:click={() => setChoice("3-2")}
                            >
                                <i class="bi bi-circle" />
                                <p>远程控制</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "3-3"}
                                on:click={() => setChoice("3-3")}
                            >
                                <i class="bi bi-circle" />
                                <p>升级管理</p>
                            </a>
                        </li>
                        {#if permits.includes("P001")}
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "3-4"}
                                on:click={() => setChoice("3-4")}
                            >
                                <i class="bi bi-circle" />
                                <p>修正工具</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "3-5"}
                                on:click={() => setChoice("3-5")}
                            >
                                <i class="bi bi-circle" />
                                <p>数据清除</p>
                            </a>
                        </li>
                        {/if}
                    </ul>
                </li>
                {/if}
                {#if permits.includes("P000")}
                <li class="nav-item">
                    <a
                        href={"javascript:;"}
                        class="nav-link"
                        class:active={choice.startsWith("0-")}
                    >
                        <i class="nav-icon bi bi-gear" />
                        <p>
                            系统管理
                            <i class="right bi bi-chevron-left" />
                        </p>
                    </a>
                    <ul class="nav nav-treeview">
                        {#if permits.includes("P000")}
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "0-1"}
                                on:click={() => setChoice("0-1")}
                            >
                                <i class="bi bi-circle" />
                                <p>角色管理</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "0-2"}
                                on:click={() => setChoice("0-2")}
                            >
                                <i class="bi bi-circle" />
                                <p>用户管理</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                href={"javascript:;"}
                                class="nav-link"
                                class:active={choice === "0-3"}
                                on:click={() => setChoice("0-3")}
                            >
                                <i class="bi bi-circle" />
                                <p>系统日志</p>
                            </a>
                        </li>
                        {/if}
                    </ul>
                </li>
                {/if}
            </ul>
        </nav>
    </div>
</aside>

<style>
</style>
